/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamSignalCreate = {
    properties: {
        teamAuditLogId: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'uuid4',
            }, {
                type: 'null',
            }],
        },
        userText: {
            type: 'string',
            isRequired: true,
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
